// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Interval } from '@shared/utils/History/Interval';
import { IndicatorHistoryType, Period } from '../../IndicatorEnums';
import { TimeSpan } from '@shared/utils/Time/TimeSpan';
export class VWAPCalculator {
    constructor(daysCount, timeInterval) {
        this.sumSize = 0;
        this.sumPriceSize = 0;
        this.lastVWAPValue = 0;
        this.updateParameters(daysCount, timeInterval);
    }
    get LastVWAPValue() {
        return this.lastVWAPValue;
    }
    CalculateVWAP(dateTime, volume, price) {
        if (this.TryCreateNewCycle(dateTime)) {
            this.sumSize = 0;
            this.sumPriceSize = 0;
            this.lastVWAPValue = 0;
        }
        if (this.AllowCalculateVWAP(dateTime)) {
            this.sumSize += volume;
            this.sumPriceSize += price * volume;
            this.lastVWAPValue = this.sumPriceSize / this.sumSize;
        }
    }
    IsValidTimeFrame(historyData) {
        const historyType = historyData.cashItem.ChartDataType;
        const period = historyData.Period;
        if (historyType === IndicatorHistoryType.Simple && period !== Period.Second) {
            return true;
        }
        else if (historyType === IndicatorHistoryType.Kagi && period !== Period.Tick && period !== Period.Second) {
            return true;
        }
        else if (historyType === IndicatorHistoryType.PnF && period !== Period.Tick && period !== Period.Second) {
            return true;
        }
        else if (historyType === IndicatorHistoryType.HeikinAshi && period !== Period.Second) {
            return true;
        }
        else {
            return false;
        }
    }
    AllowSetVWAP(dateTime) {
        return (this.currentCycleInterval != null &&
            this.currentCycleInterval.From <= dateTime &&
            this.currentCycleInterval.To >= dateTime);
    }
    cleanInterval() {
        this.currentCycleInterval = null;
    }
    updateParameters(daysCount, timeInterval) {
        this.daysCount = daysCount;
        this.timeInterval = timeInterval;
    }
    AllowCalculateVWAP(dateTime) {
        if (this.AllowSetVWAP(dateTime)) {
            const startInMins = this.timeInterval.getStartInMins();
            const endInMins = this.timeInterval.getEndInMins();
            const dateTimeInMins = dateTime.getHours() * 60 + dateTime.getMinutes();
            const isNextDayIntervalTime = startInMins > endInMins;
            if (isNextDayIntervalTime) {
                return dateTimeInMins >= startInMins || dateTimeInMins < endInMins;
            }
            else {
                return dateTimeInMins >= startInMins && dateTimeInMins < endInMins;
            }
        }
        else {
            return false;
        }
    }
    TryCreateNewCycle(dateTime) {
        if (this.currentCycleInterval == null || this.currentCycleInterval.To <= dateTime) {
            this.currentCycleInterval = this.CreateCycleInterval(dateTime);
            return true;
        }
        else {
            return false;
        }
    }
    CreateCycleInterval(dateTime) {
        const date = new Date(dateTime);
        date.setHours(0, 0, 0, 0);
        if (!isNullOrUndefined(this.currentCycleInterval) && this.currentCycleInterval.To === date) {
            date.setDate(date.getDate() + 1);
        }
        const startInMins = this.timeInterval.getStartInMins();
        const endInMins = this.timeInterval.getEndInMins();
        const isNextDayIntervalTime = startInMins > endInMins;
        const from = new Date(date.getTime() + TimeSpan.FromMinToMs(startInMins));
        const to = new Date(date);
        to.setDate(date.getDate() + (this.daysCount - 1) + (isNextDayIntervalTime ? 1 : 0));
        const intervalTo = new Date(to.getTime() + TimeSpan.FromMinToMs(endInMins + 1));
        intervalTo.setMilliseconds(-1);
        return new Interval(from, intervalTo);
    }
}
